import { Link } from "@remix-run/react";
import { ArticleMeta } from "~/.server/content.server";
import { DateDisplay } from "./date-display";

interface ArticleCardProps {
  article: ArticleMeta;
  className?: string;
}

export function ArticleCard({ article, className }: ArticleCardProps) {
  return (
    <Link
      to={`/${article.type === 'video' ? 'videos' : 'kb'}/${article.slug}`}
      className={`block rounded-lg border border-slate-200 p-6 hover:border-blue-300 hover:shadow-md transition-all ${className}`}
    >
      <div className="flex items-center justify-between mb-2">
        <DateDisplay 
          timestamp={article.created_timestamp} 
          showRelative={true} 
          className="text-sm text-slate-500" 
        />
        <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          {article.category}
        </span>
      </div>
      
      <h3 className="text-lg font-semibold mb-2">{article.title}</h3>
      
      <p className="text-slate-600 text-sm mb-4 line-clamp-2">
        {article.summary}
      </p>
      
      <div className="flex items-center">
        {article.type === 'video' ? (
          <span className="flex items-center text-sm text-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
            </svg>
            Watch Video
          </span>
        ) : (
          <span className="flex items-center text-sm text-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
            Read Article
          </span>
        )}
      </div>
    </Link>
  );
} 